import Vue from "vue";
import VueRouter from "vue-router";
import vuetify from "./plugins/vuetify";
import { routes } from "./routes";
import store from "./stores/index";
import { firebaseListener } from "./Config/firebaseConfig";
import firebase from "./Config/firebaseConfig";
import Buefy from "buefy";
import "buefy/dist/buefy.css";
import App from "./App.vue";

Vue.prototype.$fb = firebase;
Vue.use(VueRouter);
Vue.use(Buefy);

firebaseListener(authStatusChange);

const router = new VueRouter({
  mode: "history",
  routes,
});

// router.beforeEach((to, from, next) => {
//     if (to.onlyGuest && store.getters.isLoggedIn) {
//         next('/');
//     } else {
//         next();
//     }
// });

new Vue({
  el: "#app",
  router,
  store,
  vuetify,
  render: (h) => h(App),
});

function authStatusChange(loggedIn, user) {
  if (store) {
    store.commit("AUTH_STATUS_CHANGE");
    if (user) {
      store.dispatch("getShoppingCart", {
        uid: user.uid,
        currentCart: store.getters.cartItemList,
      });
    }
  }
}

router.beforeEach((to, _, next) => {
  if (to.matched.some((routeRecord) => routeRecord.meta.authRequired)) {
    if (store.state.isLoggedIn) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
